import Store from '@ember-data/store';
import Route from '@ember/routing/route';
import { service } from '@ember/service';
import { tracked } from '@glimmer/tracking';
import { BeginUploadEventBus } from 'donor-elf-web/components/upload-file-item';
import UploadFileModel from 'donor-elf-web/models/admin/upload-file';
import NavbarSettingsService from 'donor-elf-web/services/navbar-settings';

export class AdminUploadNewRouteModel {
  @tracked uploadFiles: UploadFileModel[] = [];
  beginUploadEventBus: any;
  changeset: any;
}

export default class AdminUploadNewRoute extends Route {
  @service declare navbarSettings: NavbarSettingsService;
  @service declare store: Store;

  beforeModel() {
    this.navbarSettings.title = 'Upload Reports';
  }

  async model(): Promise<AdminUploadNewRouteModel> {
    // have to call `query` instead of `findAll` because findAll includes models
    // from previous calls to the api

    const model = new AdminUploadNewRouteModel();
    model.uploadFiles = (
      await this.store.query('admin/upload-file', {})
    ).slice();
    model.beginUploadEventBus = BeginUploadEventBus.create();
    model.changeset = {
      uploadAll: false,
    };

    return model;
  }

  resetController(controller: any, isExiting: boolean) {
    if (isExiting) {
      controller.reset();
    }
  }
}
